const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        accidentDate: 'Unfalldatum',
        accidentInsurance: 'Unfallversicherung',
        accidentType: 'Art des Unfalls',
        accInsuranceUvg: 'Unfallversicherung nach UVG?',
        address: 'Adresse',
        ahv: 'Sozialversicherungsnummer/AHV-Nr.',
        arbeitgeber: 'Arbeitgeber',
        assigner: 'Zuweiser*in',
        assignPraxis: 'Spital/Klinik/Praxis',
        basicInsurance: 'Name der Grundversicherung',
        behandlungsgrund: 'Behandlungs\u00ADgrund',
        beziehung: 'Beziehung',
        co: 'c/o',
        confirmCosts:
            'Sie haben Zusatzversicherungsleistungen und bestätigen hiermit die Übernahme der Kosten bei einer allfälligen Unterdeckung oder eines Ausschlusses. Details entnehmen Sie aus dem Informationsschreiben (Wenn Sie dies nicht wünschen, muss die Versicherungsdeckung unter der Rubrik Versicherungsangabe angepasst werden auf Allgemein).',
        correspondenceAddress: 'Ich habe eine abweichende Korrespondenz-Adresse',
        country: 'Land',
        dateOfBirth: 'Geburtstag',
        dueDate: 'Errechneter Geburtstermin',
        einwArzt: 'Hausarzt / Hausärztin',
        eMailInfo:
            'Wir werden Ihre E-Mail-Adresse für Benachrichtigungen aus dem Patient*innenportal nutzen (z.B. Hinweis, dass im Portal ein neuer Termin oder neues Dokument verfügbar ist).\nDie E-Mails enthalten nur minimale administrative Informationen und werden unverschlüsselt verschickt. Detaillierte und behandlungsrelevante Inhalte sind im Portal einsehbar.\n',
        employment: 'Ich bin',
        epd: 'EPD (elektronisches Patient*innen-Dossier) vorhanden?',
        gender: 'Geschlecht',
        hometown: 'Heimatort',
        infoBirth:
            'Gerne unterbreiten wir Ihnen folgende Upgrade-Angebote für Geburt und Wochenbett (Verfügbarkeit der Zimmer vorausgesetzt, die Angebote gelten nicht für einen allfälligen stationären Aufenthalt vor der Geburt.):',
        infoBirthDetail:
            '<ul>\n  <li>Zimmer-Upgrade für die alleinige Nutzung des Zimmers</li>\n  <li>Zimmer-Upgrade für die alleinige Nutzung des Zimmers + Übernachtung für eine Begleitperson in meinem Zimmer inkl. Frühstück</li>\n  <li>Ärztliches Upgrade (inkl. Zimmer-Upgrade): Betreuung und Behandlung während Geburt und Wochenbett durch eine*n Fachärzt*in für Gynäkologie und Geburtshilfe</li>\n</ul>',
        infoBirthDetailHP:
            '<ul>\n  <li>Zimmer-Upgrade für die alleinige Nutzung des Zimmers + Übernachtung für eine Begleitperson in meinem Zimmer inkl. Frühstück</li>\n </ul>',
        infoEndPart:
            '<div>\nMehr Infos zu den Upgrades: <a target="_blank" href="http://stadtspital.ch/upgrade">Ihre Upgrade-Möglichkeiten</a>\n</div>\n<div>\nFür Fragen und Auskünfte steht Ihnen unser Team gerne zur Verfügung:\n+41 44 416 03 25\n</div>',
        infoGeneral:
            '<div>Stationäre Patient*innen (inkl. Geburtenabteilung/Wochenbett) haben die Möglichkeit, ein Komfort-/Klassen-Upgrade zu buchen.\n </div><br>',
        infoInsurance: 'Versicherungsangabe',
        insucanceAdd: 'Weitere Angaben zur Versicherung',
        insuranceCoverage: 'Versicherungsdeckung',
        insuranceNumber: 'Versicherungsnummer',
        insuranceNumberHelperText: 'Die Versicherungsnummer finden Sie unter anderem auf Ihrer Versicherungskarte',
        kanton: 'Kanton',
        keineKonaktperson: 'Keine Kontaktperson',
        keinHausarzt: 'Keine Hausärzt*in/Gruppenpraxis',
        kontakt: 'Kontaktperson / Angehörige',
        medReportAssigner: 'Medizinische Berichte: Zustellung an Zuweiser?',
        medReportGP: 'Medizinische Berichte: Zustellung an Hausarzt?',
        mobileNumberInfo:
            'Die Mobile-Nr. wird für die 2-Faktor-Authentifizierung und für Terminerinnerungen verwendet.',
        nationality: 'Nationalität',
        noAHV: 'Ich habe keine Sozialversicherungsnummer.',
        noVeka: 'Ich habe keine Karten-Nr. / VEKA-Nr.',
        paf: 'Patient*innen-Verfügung vorhanden?',
        pafInfoText: 'Bitte bringen Sie Ihre Patient*innen-Verfügung zum Behandlungstermin mit.',
        persAngaben: 'Persönliche Angaben',
        persAngabenInfoText:
            'Erfassung Ihrer persönlichen Angaben gemäss Pass/ID oder Schweizer Niederlassungsbewilligung',
        policyNumber: 'Versicherungs-/Policen-Nr.',
        praxis: 'Praxis',
        profession: 'Beruf',
        refNumber: 'Schadens-/Referenz-Nr.',
        religion: 'Religion/Konfession',
        religion_other: 'Andere Religion/Konfession',
        representative: 'Vertretungsberechtigte Person',
        secondContact: 'Weitere Kontaktperson?',
        streetAndNumber: 'Strasse und Nr.',
        tel: 'Telefon',
        telephoneMobile: 'Mobile',
        twinBirth: 'Zwillingsgeburt',
        upgradeCoverage:
            'Ich möchte bei einem Spitalaufenthalt (Flex-/Wahl-Versicherungen) folgende Leistungen in Anspruch nehmen.',
        veka: 'Karten-Nr. / VEKA-Nr.',
        vekaHelperText: 'Die 20-stellige Karten-Nr. / VEKA-Nr. finden Sie unter anderem auf Ihrer Versicherungs-karte.',
        versicherungLabel: 'Ver\u00ADsicherung',
        vvg: 'Meine Zusatzversicherung (VVG) ist bei der gleichen Krankenkasse wie die Grundversicherung (OKP).',
        vvgInsuranceNumber: 'Versicherungsnummer',
        vvgName: 'Name der Zusatzversicherung',
        vvgVeka: 'Karten-Nr. / VEKA-Nr.',
        wohnsitz: 'Wohnsitz',
        wohnsitzHinweis: 'Bitte Wohnadresse (Steuerrechtlicher Wohnsitz) eintragen',
        zivilstand: 'Zivilstand',
    },
    __RELATIVE_SOURCE_FILE__
);
